/*eslint-disable*/
import {
  Card,
  CardContent,
  FormControl,
  Grid,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Typography
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React from "react";
import { Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import 
      {
        fnaResult, 
        cgtAsset, 
        incomeNeedAtDeath, 
        incomeProvisionAtDeath, 
        assetsDisabilityCgt, 
        disabilityIncomeNeed, 
        disabilityIncomeProvision
      } from "./objects/FNA_result_vars.js"
import assumptions from "./objects/assumptions.js"
import Assumptions from "./Assumptions.jsx";
const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const required = value => (value ? undefined : "Required");

class OtherInformation extends React.Component 
{
  componentDidMount() 
  {
    this.props.scrollMeBar();
    this.props.state.result = new fnaResult().fna;
  }

  calcBalanceSheet()
  {
    
    this.props.state.assets.map((e, i) => 
    {
      
      var balanceSheetAsset = {};
      balanceSheetAsset.description = e.description;
      balanceSheetAsset.ownershipClient = e.ownershipClient/100 * e.marketValue;
      balanceSheetAsset.ownershipSpouse = e.ownershipSpouse/100 * e.marketValue;
      this.props.state.result.balanceSheet.netAssetsClient += balanceSheetAsset.ownershipClient;
      this.props.state.result.balanceSheet.netAssetsSpouse += balanceSheetAsset.ownershipSpouse

      this.props.state.result.balanceSheet.assets.push(balanceSheetAsset);

      var balanceSheetLiability = {};
      if(e.liability > 0)
      {
        if(e.ownershipClient > 0)
        {
          balanceSheetLiability.description = e.description;
          balanceSheetLiability.amountClient = parseFloat(e.liability) * e.ownershipClient/100;

          this.props.state.result.balanceSheet.netLiabilitiesClient += parseFloat(balanceSheetLiability.amountClient);
          
        }

        if(e.ownershipSpouse > 0)
        {
         
          balanceSheetLiability.description = e.description;
          balanceSheetLiability.amountSpouse = parseFloat(e.liability) * e.ownershipSpouse/100;

          this.props.state.result.balanceSheet.netLiabilitiesSpouse += parseFloat(balanceSheetLiability.amountSpouse);
          
        }
        if(e.ownershipSpouse > 0 || e.ownershipClient > 0)
          this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);
        
      }
    })

    this.props.state.liabilities.map((e, i) => 
    {
      var balanceSheetLiability = {};
      balanceSheetLiability.description = e.description;
      if(e.party == "client")
      {
        balanceSheetLiability.amountClient = parseFloat(e.amount);
        this.props.state.result.balanceSheet.netLiabilitiesClient += parseFloat(e.amount);
      }
      else
      {
        balanceSheetLiability.amountSpouse = parseFloat(e.amount);
        this.props.state.result.balanceSheet.netLiabilitiesSpouse += parseFloat(e.amount);
      }
        
      this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);
    })


    this.props.state.policy.map((e, i) => 
    {
      if(e.party == "client")
      {
        var balanceSheetPolicy = {};
        balanceSheetPolicy.description = e.description;
        
        if(e.LifeAssured == "client")
        {
          balanceSheetPolicy.amountClient = parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.netPoliciesClient += parseFloat(e.cashValue);
        }
        else
        {
          balanceSheetPolicy.amountSpouse = parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.netPoliciesSpouse += parseFloat(e.cashValue);
        }
          
        this.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);
      }
    })

    this.props.state.result.balanceSheet.netTotalAssetsClient = parseFloat(this.props.state.result.balanceSheet.netAssetsClient) + parseFloat(this.props.state.result.balanceSheet.netPoliciesClient)  - parseFloat(this.props.state.result.balanceSheet.netLiabilitiesClient);
    this.props.state.result.balanceSheet.netTotalAssetsSpouse = parseFloat(this.props.state.result.balanceSheet.netAssetsSpouse) + parseFloat(this.props.state.result.balanceSheet.netPoliciesSpouse) - parseFloat(this.props.state.result.balanceSheet.netLiabilitiesSpouse);

    this.props.state.result.executorFees.percentageApplicable = this.props.state.execFee;
    this.props.state.result.executorFees.vat = this.props.state.vat;
    this.props.state.result.executorFees.executorFee = parseFloat(this.props.state.result.balanceSheet.netAsset) * parseFloat(this.props.state.execFee)/100 * parseFloat(this.props.state.vat)/100;


  }


  calcCgt()
  {

    this.props.state.assets.map((e, i) => 
    {
      if(e.cgtPayable)
      {
        var temp = cgtAsset;
        temp.description = e.description;
        temp.e.category = e.e.category
        temp.marketValue = e.marketValue;
        temp.baseCost = e.baseCost;
        temp.capitalGain = e.marketValue - e.baseCost;
        temp.bequethedToSpouse = e.spouseInherit/100 *  e.marketValue;
        temp.residueTospouse = this.props.state.residueAmount/100 * e.marketValue;
        temp.netGain = temp.capitalGain - temp.bequethedToSpouse - temp.residueTospouse;
        

        this.props.state.result.cgt.netCgtMarketValue += e.marketValue;
        this.props.state.result.cgt.netClientsBaseCost += e.baseCost;
        this.props.state.result.cgt.netClientsCapitalGain += temp.capitalGain;
        this.props.state.result.cgt.netCashBequestTospouse += temp.bequethedToSpouse;
        this.props.state.result.cgt.netResidueTospouse += temp.residueTospouse;
        this.props.state.result.cgt.netSpouseCapitalGain += temp.netGain;
        if(e.category != "primary_residential")
        {
          this.props.state.result.cgt.netClientsCapitalGainDisplay += temp.capitalGain;
        }


        this.props.state.result.cgt.cgtAssets.push(temp);
        
        if(e.category == "primary_residential")
        {
          if(temp.capitalGain - this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion > 0)
            temp.capitalGain =  temp.capitalGain - this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion
          else
            temp.capitalGain = 0.00


          this.props.state.result.cgt.netClientsCapitalGainDisplay += temp.capitalGain;
          this.props.state.result.cgt.pResidence = temp;
        }
         
       
          
      }
      if(this.props.state.result.cgt.netClientsCapitalGain > 0)
        this.props.state.result.cgt.capitalGain = this.props.state.result.cgt.netClientsCapitalGain;


        //Primary residense exlusion
        if(e.category == "primary_residential")
        {
          if(temp.netGain > assumptions.primary_residence_exemption )
            this.props.state.result.cgt.minuspResidence.primaryResidence = assumptions.primary_residence_exemption
          else
            this.props.state.result.cgt.minuspResidence.primaryResidence = temp.netGain

        if(temp.netGain < -1*assumptions.primary_residence_exemption )
            this.props.state.result.cgt.minuspResidence.primaryResidenceLoss = -1*assumptions.primary_residence_exemption
          else
            this.props.state.result.cgt.minuspResidence.primaryResidenceLoss = temp.netGain
        }
           
      
     
    })

    this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion = assumptions.primary_residence_exemption;
    this.props.state.result.cgt.minuspResidence.primaryResidenceLossExclusion = -1 * assumptions.primary_residence_exemption;
    this.props.state.result.cgt.minuspResidence.netExclusion = this.props.state.result.cgt.minuspResidence.primaryResidence + this.props.state.result.cgt.minuspResidence.primaryResidenceLoss;
    this.props.state.result.cgt.netMinusExlusion = this.props.state.result.cgt.netClientsCapitalGain - this.props.state.result.cgt.minuspResidence.netExclusion

    this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse = this.props.state.result.cgt.netCashBequestTospouse;
    this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse = this.props.state.result.cgt.netResidueTospouse;
    this.props.state.result.cgt.minusspouseRollOver.netRollOver = this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse + this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse;
    this.props.state.result.cgt.netMinusRollOver = this.props.state.result.cgt.netMinusExlusion - this.props.state.result.cgt.minusspouseRollOver.netRollOver;

    this.props.state.result.cgt.minusPreviousLoss = this.props.state.capitalLossAmount;
    this.props.state.result.cgt.netMinusPreviousLoss = this.props.state.result.cgt.netMinusRollOver - this.props.state.result.cgt.minusPreviousLoss;

    this.props.state.result.cgt.minusExclusionAtDeath = assumptions.cgtExclusionAtDeath
    if(this.props.state.result.cgt.netMinusPreviousLoss > 0)
      this.props.state.result.cgt.netMinusExlusionAtDeath = this.props.state.result.cgt.minusExclusionAtDeath
    else
      this.props.state.result.cgt.netMinusExlusionAtDeath = 0;
    
    this.props.state.result.cgt.netCgt = this.props.state.result.cgt.netMinusPreviousLoss - this.props.state.result.cgt.netMinusExlusionAtDeath;

    this.props.state.result.cgt.marginalTax = this.props.state.marginalTax

    this.props.state.result.cgt.inclusionRate = assumptions.inclusion_rate_for_cgt
    
    if(this.props.state.result.cgt.netCgt > 0)
      this.props.state.result.cgt.cgtPayable = this.props.state.result.cgt.netCgt * this.props.state.result.cgt.marginalTax/100 * this.props.state.result.cgt.inclusionRate/100
    else
    this.props.state.result.cgt.cgtPayable = 0;
    
    
    console.log(this.props.state.result)
        
       



  }

  calcEstateDuty()
  {
    this.props.state.assets.map((e, i) => 
    {
      if(e.category == "farms_owned")
        this.props.state.result.estateDuty.assets.netFarms += e.ownershipClient/100 * marketValue;
      else
        if(e.category == "usufruct_annuity_charged_on_property_or_similar_right")
          this.props.state.result.estateDuty.assets.netDeemedAssets += e.ownershipClient/100 * marketValue;
      else
        this.props.state.result.estateDuty.assets.netAssets += e.ownershipClient/100 * marketValue;
    })

    this.props.state.policy.map((e, i) => 
    {
      if(!e.dutyExcempt)
        if(e.LifeAssured == "Client")
        {
          this.props.state.result.estateDuty.assets.netPoliciesOnLife += e.death;

          this.props.state.result.estateDuty.deductions.netPoliciesToSpouse += e.death * e.spouse/100
        }
          else 
            if(e.party == "Client")
              this.props.state.result.estateDuty.assets.netPoliciesWithChash += e.cashValue;

       
    })

    this.props.state.result.estateDuty.assets.netEstateAssets = this.props.state.result.estateDuty.assets.netFarms + 
                                                          this.props.state.result.estateDuty.assets.netDeemedAssets + 
                                                          this.props.state.result.estateDuty.assets.netAssets + 
                                                          this.props.state.result.estateDuty.assets.netPoliciesOnLife + 
                                                          this.props.state.result.estateDuty.assets.netPoliciesWithChash + 
                                                          this.props.state.result.estateDuty.assets.netAccrualClaim;
                                                          
    
     this.props.state.result.estateDuty.deductions.netLiabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
     this.props.state.result.estateDuty.deductions.netAdministration = this.props.state.adminCost;
     this.props.state.result.estateDuty.deductions.netFuneral = this.props.state.funeralCost;
     this.props.state.result.estateDuty.deductions.netMastersFee = assumptions.masters_fees;
     this.props.state.result.estateDuty.deductions.netExectutorsFee = 0.00 //Still need to ass Executor's fee
     this.props.state.result.estateDuty.deductions.netCapitalGainTax = this.props.state.result.cgt.cgtPayable;

     this.props.state.assets.map((e, i) => 
    {
      if((e.category == "farms_owned" || e.category == "primary_residential" || e.category == "other_residential") && !e.liquid)
        this.props.state.result.estateDuty.deductions.netTransferCosts += e.marketValue //Should this only be the Client's portion??

        this.props.state.result.estateDuty.deductions.netBequethedAssets += e.marketValue * e.spouseInherit /100
    })
    this.props.state.result.estateDuty.deductions.netTransferCosts = this.props.state.result.estateDuty.deductions.netTransferCosts * assumptions.transfer_costs / 100;

    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if(e.category == "cashBequest" || e.category == "cashBequestCharity")
      {
        this.props.state.result.estateDuty.deductions.netCashBequestTospouse += e.mounthlyAmount * e.spouseInherit /100 

        this.props.state.result.estateDuty.deductions.netCashBequestToCharity += e.mounthlyAmount * e.charityInherit /100 
      }
        
    })

    this.props.state.result.estateDuty.deductions.netResidueTospouse = 0.00 //Still need to work out Residue first.

    this.props.state.result.estateDuty.deductions.netAccrualClaim = this.props.state.spouseAccrualValue;

    this.props.state.result.estateDuty.deductions.netDeductions = this.props.state.result.estateDuty.deductions.netLiabilities +
                                                                  this.props.state.result.estateDuty.deductions.netAdministration +
                                                                  this.props.state.result.estateDuty.deductions.netFuneral +
                                                                  this.props.state.result.estateDuty.deductions.netMastersFee +
                                                                  this.props.state.result.estateDuty.deductions.netExectutorsFee +
                                                                  this.props.state.result.estateDuty.deductions.netCapitalGainTax +
                                                                  this.props.state.result.estateDuty.deductions.netTransferCosts +
                                                                  this.props.state.result.estateDuty.deductions.netBequethedAssets +
                                                                  this.props.state.result.estateDuty.deductions.netCashBequestTospouse +
                                                                  this.props.state.result.estateDuty.deductions.netCashBequestToCharity +
                                                                  this.props.state.result.estateDuty.deductions.netResidueTospouse +
                                                                  this.props.state.result.estateDuty.deductions.netPoliciesToSpouse +
                                                                  this.props.state.result.estateDuty.deductions. netAccrualClaim;

    this.props.state.result.estateDuty.netEstate = this.props.state.result.estateDuty.assets.netEstateAssets - this.props.state.result.estateDuty.deductions.netDeductions;
    this.props.state.result.estateDuty.minusRebate = assumptions.estate_duty_exemption;
    this.props.state.result.estateDuty.minusRebateFromPreviousSpouse = this.props.state.rebateUsed;
    this.props.state.result.estateDuty.taxableEstate = this.props.state.result.estateDuty.netEstate - this.props.state.result.estateDuty.minusRebate - this.props.state.result.estateDuty.minusRebateFromPreviousSpouse;
    if(this.props.state.result.estateDuty.taxableEstate < 0)
      this.props.state.result.estateDuty.taxableEstate = 0.00;
    
    if(this.props.state.result.estateDuty.taxableEstate <= 30000000)
      this.props.state.result.estateDuty.estateDutyPayable = this.props.state.result.estateDuty.taxableEstate * assumptions.estateDutyLT /100
    else
    this.props.state.result.estateDuty.estateDutyPayable = this.props.state.result.estateDuty.taxableEstate * assumptions.estateDutyGT /100

    this.props.state.policy.map((e, i) => 
    {
      if(!e.dutyExcempt)
      {
        this.props.state.result.estateDuty.payableByOther += e.death * e.other/100
      }
    })

    this.props.state.result.estateDuty.payableByOther = this.props.state.result.estateDuty.payableByOther/this.props.state.result.estateDuty.netEstate * this.props.state.result.estateDuty.estateDutyPayable;
    this.props.state.result.estateDuty.payableByEstate = this.props.state.result.estateDuty.estateDutyPayable - this.props.state.result.estateDuty.payableByOther;

  }

  calcLiquidity()
  {
    this.props.state.result.liquidity.cashNeeded.netCgt = this.props.state.result.cgt.cgtPayable;
    this.props.state.result.liquidity.cashNeeded.netLiabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
    this.props.state.result.liquidity.cashNeeded.netExectutorsFee = this.props.state.result.executorFees.executorFee;
    this.props.state.result.liquidity.cashNeeded.netEstateDuty = this.props.state.result.estateDuty.payableByEstate;
    this.props.state.result.liquidity.cashNeeded.netOtherCosts = this.props.state.result.deductions.netAdministration + this.props.state.result.deductions.netFuneral + this.props.state.result.deductions.netMastersFee + this.props.state.result.deductions.netTransferCosts;
    //this.props.state.result.liquidity.cashNeeded.netBequethedAssets =       //Still need to consult if this needs to be in here.
    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if((e.category == "cashBequest" || e.category == "cashBequestCharity") && e.death)
      {
        this.props.state.result.liquidity.cashNeeded.netCashBequests += e.mounthlyAmount
      }
        
    })

    //this.props.state.result.liquidity.cashNeeded.netAccrualClaim =                //First need to calculate accrual.

    this.props.state.result.liquidity.cashNeeded.netCashNeeded = this.props.state.result.liquidity.cashNeeded.netCgt +
                                                                  this.props.state.result.liquidity.cashNeeded.netLiabilities + 
                                                                  this.props.state.result.liquidity.cashNeeded.netExectutorsFee + 
                                                                  this.props.state.result.liquidity.cashNeeded.netEstateDuty +
                                                                  this.props.state.result.liquidity.cashNeeded.netOtherCosts +
                                                                  this.props.state.result.liquidity.cashNeeded.netBequethedAssets +
                                                                  this.props.state.result.liquidity.cashNeeded.netCashBequests +
                                                                  this.props.state.result.liquidity.cashNeeded.netAccrualClaim

    
    this.props.state.assets.map((e, i) => 
    {
      if((e.category != "primary_residential" && e.category != "other_residential" && e.category != "farms_owned" && e.category != "usufruct_annuity_charged_on_property_or_similar_right") || e.liquid)
      {
        if(e.liquid)
          this.props.state.result.liquidity.cashAvailable.netCashAssets += e.marketValue;
        else
          this.props.state.result.liquidity.cashAvailable.netLiquidInvestments = e.marketValue;
      }
        
    })

    this.props.state.policy.map((e, i) => 
    {
      if(e.party == "client")
        this.props.state.result.liquidity.cashAvailable.netPolicies += e.death * estate/100
    })
     
    this.props.state.result.liquidity.cashAvailable.netCashAvailable = this.props.state.result.liquidity.cashAvailable.netCashAssets +
                                                                        this.props.state.result.liquidity.cashAvailable.netLiquidInvestments +
                                                                        this.props.state.result.liquidity.cashAvailable.netPolicies
                                                    
    this.props.state.result.liquidity.cash = this.props.state.result.liquidity.cashAvailable.netCashAvailable - this.props.state.result.liquidity.cashNeeded.netCashNeeded;

  }

  calcAccrual()
  {
    this.props.state.result.accrual.current.valueOfAssets.client = this.props.state.result.balanceSheet.netAssetsClient;
    this.props.state.result.accrual.current.valueOfAssets.spouse = this.props.state.result.balanceSheet.netAssetsSpouse;

    this.props.state.policy.map((e, i) => 
    {
      if(e.LifeAssured == "client")
        this.props.state.result.accrual.current.valueOfAssets.client += e.cashValue;
      if(e.LifeAssured == "spouse")
        this.props.state.result.accrual.current.valueOfAssets.spouse += e.cashValue;

        if(e.party == "client")
          this.props.state.result.accrual.current.valueOfPolicies += e.death * e.estate/100;
      
    })

    this.props.state.result.accrual.current.minusLiabilities.client = this.props.state.result.balanceSheet.netLiabilitiesClient;
    this.props.state.result.accrual.current.minusLiabilities.spouse = this.props.state.result.balanceSheet.netLiabilitiesSpouse;

    this.props.state.result.accrual.current.netValue.client = this.props.state.result.accrual.current.valueOfAssets.client +
                                                              this.props.state.result.accrual.current.valueOfPolicies -
                                                              this.props.state.result.accrual.current.minusLiabilities.client

    this.props.state.result.accrual.current.netValue.spouse = this.props.state.result.accrual.current.valueOfAssets.spouse -
                                                              this.props.state.result.accrual.current.minusLiabilities.spouse

    this.props.state.result.accrual.assetValueExcluded.client = this.props.state.accrualExcludedClient;
    this.props.state.result.accrual.assetValueExcluded.spouse = this.props.state.accrualExcludedSpouse;

    this.props.state.result.accrual.atMarriage.valueANC.client = this.props.state.accrualExcludedMarrageClient;
    this.props.state.result.accrual.atMarriage.valueANC.spouse = this.props.state.accrualExcludedMarrageSpouse;

    this.props.state.result.accrual.netAccrual.client = this.props.state.result.accrual.current.netValue.client - this.props.state.result.accrual.assetValueExcluded.client;
    this.props.state.result.accrual.netAccrual.spouse = this.props.state.result.accrual.current.netValue.spouse - this.props.state.result.accrual.assetValueExcluded.spouse;

    if(this.props.state.result.accrual.netAccrual.client < 0)
      this.props.state.result.accrual.netAccrual.client = 0.00

    if(this.props.state.result.accrual.netAccrual.spouse < 0)
      this.props.state.result.accrual.netAccrual.spouse = 0.00

    if(this.props.state.result.accrual.netAccrual.spouse - this.props.state.result.accrual.netAccrual.client > 0)
      this.props.state.result.accrual.claimAgainstSpouse = (this.props.state.result.accrual.netAccrual.spouse - this.props.state.result.accrual.netAccrual.client)/2

    if(this.props.state.result.accrual.netAccrual.client - this.props.state.result.accrual.netAccrual.spouse  > 0)
      this.props.state.result.accrual.clainBySpouse = (this.props.state.result.accrual.netAccrual.client - this.props.state.result.accrual.netAccrual.spouses)/2

  }

  calcResidue()
  {
    this.props.state.result.residue.totalAssets = this.props.state.result.estateDuty.assets.netEstateAssets;
    this.props.state.result.residue.policies = 0.00; // Must make sure what policies needs to be used here.
    


    this.props.state.assets.map((e, i) => 
    {
      this.props.state.result.residue.bequestsToOther += e.marketValue * e.ownershipClient/100 * e.otherInherit/100 + e.marketValue * e.ownershipClient/100 * e.charityInherit/100;
      this.props.state.result.residue.bequestsToSpouse += e.marketValue * e.ownershipClient/100 * e.spouseInherit/100;
        
    })

    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if((e.category == "cashBequest" || e.category == "cashBequestCharity") && e.death)
      {
        this.props.state.result.residue.cashBequestsToOther += e.mounthlyAmount * e.otherInherit/100 + e.mounthlyAmount * e.charityInherit/100;
        this.props.state.result.residue.cashBequestsToSpouse += e.mounthlyAmount * e.spouseInherit/100;
      }
    })

    this.props.state.result.residue.liabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
      this.props.state.result.residue.costs = this.props.state.result.estateDuty.deductions.netAdministration + 
                                              this.props.state.result.estateDuty.deductions.netFuneral +
                                              this.props.state.result.estateDuty.deductions.netMastersFee +
                                              this.props.state.result.estateDuty.deductions.netExectutorsFee +
                                              this.props.state.result.estateDuty.deductions.netCapitalGainTax +
                                              this.props.state.result.estateDuty.deductions.netTransferCosts

    this.props.state.result.residue.accrualClaimBySpouse = this.props.state.result.accrual.clainBySpouse;

    this.props.state.result.residue.minus = this.props.state.result.residue.policies +
                                            this.props.state.result.residue.bequestsToOther +
                                            this.props.state.result.residue.cashBequestsToOther +
                                            this.props.state.result.residue.bequestsToSpouse +
                                            this.props.state.result.residue.cashBequestsToSpouse +
                                            this.props.state.result.residue.liabilities +
                                            this.props.state.result.residue.costs +
                                            this.props.state.result.residue.accrualClaimBySpouse
    
    this.props.state.result.residue.residueBeforeEstateDuty = this.props.state.result.residue.totalAssets - this.props.state.result.residue.minus;
    if(this.props.state.result.residue.residueBeforeEstateDuty < 0)
      this.props.state.result.residue.residueBeforeEstateDuty = 0.00;

    this.props.state.result.residue.minusEstateDuty = this.props.state.result.estateDuty.payableByEstate;
    this.props.state.result.residue.residue = this.props.state.result.residue.residueBeforeEstateDuty - this.props.state.result.residue.minusEstateDuty;
    if(this.props.state.result.residue.residue < 0)
      this.props.state.result.residue.residue = 0.00;
    
  }

  calcDeathProvision()
  {

  }

  calcDisabilityCgt()
  {

  }

  disabilityLiquidity()
  {

  }

  calcDisabilityProvision()
  {

  }

  whoof()
  {
    return JSON.stringify(this.props.state.result)
  }
  render() {
    let { checkValidation } = this.props;

    let other_information = _.get(
      store.getState().form,
      "newfna.values.other_information",
      {}
    );

    return (
      <div className="contentWithStepper">
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={"Client Name"}
              headline={"Other information"}
            />
            {this.calcBalanceSheet()}
            {this.calcCgt()}
            {this.calcAccrual()}
            {this.calcEstateDuty()}
            {this.calcLiquidity()}
            {this.calcResidue()}

            <h1>Balance Sheet</h1>

            <h2>Assets</h2>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Description
                  </TableCell>
                  <TableCell>
                    Client
                  </TableCell>
                  <TableCell>
                    Spouse
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

            {
              this.props.state.result.balanceSheet.assets.map((e,i) =>
              {
                return(
                  <TableRow>
                    <TableCell>
                      {e.description}
                    </TableCell>
                    <TableCell>
                      {e.ownershipClient}
                    </TableCell>
                    <TableCell>
                      {e.ownershipSpouse}
                    </TableCell>
                  </TableRow>
                )
              })
            }
            <TableRow>
                    <TableCell>
            <b>Total</b>
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netAssetsClient}
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netAssetsSpouse}
                    </TableCell>
            </TableRow>
            </TableBody>
            </Table>
<h3>Cash values of policies</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Description
                  </TableCell>
                  <TableCell>
                    Client
                  </TableCell>
                  <TableCell>
                    Spouse
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

            {
              this.props.state.result.balanceSheet.policies.map((e,i) =>
              {
                return(
                  <TableRow>
                    <TableCell>
                      {e.description}
                    </TableCell>
                    <TableCell>
                      {e.amountClient}
                    </TableCell>
                    <TableCell>
                      {e.amountSpouse}
                    </TableCell>
                  </TableRow>
                )
              })
            }
            <TableRow>
                    <TableCell>
            <b>Total</b>
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netPoliciesClient}
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netPoliciesSpouse}
                    </TableCell>
            </TableRow>
            </TableBody>
            </Table>

<h3>Liabilities</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Description
                  </TableCell>
                  <TableCell>
                    Client
                  </TableCell>
                  <TableCell>
                    Spouse
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

            {
              this.props.state.result.balanceSheet.liabilities.map((e,i) =>
              {
                return(
                  <TableRow>
                    <TableCell>
                      {e.description}
                    </TableCell>
                    <TableCell>
                      {e.amountClient}
                    </TableCell>
                    <TableCell>
                      {e.amountSpouse}
                    </TableCell>
                  </TableRow>
                )
              })
            }
            <TableRow>
                    <TableCell>
            <h3>Total</h3>
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netLiabilitiesClient}
                    </TableCell>
                    <TableCell>
                    {this.props.state.result.balanceSheet.netLiabilitiesSpouse}
                    </TableCell>
            </TableRow>
            </TableBody>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <h4>Net Asset value</h4>
                  </TableCell>
                  <TableCell>
                  {this.props.state.result.balanceSheet.netTotalAssetsClient}
                  </TableCell>
                  <TableCell>
                  {this.props.state.result.balanceSheet.netTotalAssetsSpouse}
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>


            <h1>Capital Gains Tax</h1>

            <h3>Assets</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Type</b>
                  </TableCell>
                  <TableCell>
                    <b>Description</b>
                  </TableCell>
                  <TableCell>
                    <b>Market value of client's share</b>
                  </TableCell>
                  <TableCell>
                    <b>Client's base cost</b>
                  </TableCell>
                  <TableCell>
                    <b>Client's capital gain</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                { 
                    this.props.state.assets.cgt.pResidence.description != ""  &&

                    (
                      <TableRow>
                        <TableCell>
                          {this.props.state.assets.cgt.pResidence.category}
                        </TableCell>
                        <TableCell>
                          {this.props.state.assets.cgt.pResidence.description}
                        </TableCell>
                        <TableCell>
                          {this.props.state.assets.cgt.pResidence.baseCost}
                        </TableCell>
                        <TableCell>
                          {this.props.state.assets.cgt.pResidence.capitalGain}
                        </TableCell>
                      </TableRow>
                    )
                }
                {
                  
                  this.props.state.result.cgt.cgtAssets.map((e,i) =>
                  {
                    if(e.category != "primary_residential")
                    return(
                      <TableRow>
                        <TableCell>
                          {e.category}
                        </TableCell>
                        <TableCell>
                          {e.description}
                        </TableCell>
                        <TableCell>
                          {e.baseCost}
                        </TableCell>
                        <TableCell>
                          {e.capitalGain}
                        </TableCell>
                      </TableRow>
                    )
                  })
                }

                 <TableRow>
                        <TableCell>
                          <h4><b>Total</b></h4>
                        </TableCell>
                        <TableCell>
                          {this.props.state.result.cgt.netCgtMarketValue}
                        </TableCell>
                        <TableCell>
                         {this.props.state.result.cgt.netClientsBaseCost}
                        </TableCell>
                        <TableCell>
                          {this.props.state.result.cgt.netClientsCapitalGainDisplay}
                        </TableCell>
                      </TableRow>
              </TableBody>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <h4><b>Net Capital Gain</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    <b>{this.props.state.result.cgt.netMinusExlusion}</b>
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <h4><b>Minus: Spouse's Roll Over</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    <b>{this.props.state.result.cgt.minusspouseRollOver.netRollOver}</b>
                  </TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
              <TableRow>
                  <TableCell>
                    Portion bequethed to Spouse
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse}
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  
                </TableRow>
                <TableRow>
                  <TableCell>
                    Portion to Spouse as part of residue
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse}
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  
                </TableRow>
                <TableRow>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                   <b>{this.props.state.result.cgt.netMinusRollOver}</b>
                  </TableCell>
                  
                </TableRow>
              </TableBody>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Minus: Previous loss carried over</b>
                  </TableCell>
                  <TableCell>
                    <b>{this.props.state.result.cgt.minusPreviousLoss}</b>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    <b>{this.props.state.result.cgt.minusPreviousLoss}</b>
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    <b>{this.props.state.result.cgt.netMinusPreviousLoss}</b>
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                   <b>Minus: Exclusion at death</b>
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.minusExclusionAtDeath}
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {
                      this.props.state.result.cgt.netMinusPreviousLoss > 0 &&
                        (
                          this.props.state.result.cgt.netMinusExlusionAtDeath
                        )
                    
                    }
                    {
                      this.props.state.result.cgt.netMinusPreviousLoss < 1 &&
                        (
                          0.00
                        )
                    
                    }
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                   <h4><b>Net CGT</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.netCgt}
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>

            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>
                   <h4><b>Marginal Tax Rate</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.marginalTax}
                  </TableCell>
                  
                </TableRow>
                <TableRow>
                  <TableCell>
                   <h4><b>Inclusion rate</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.inclusionRate}
                  </TableCell>
                  
                </TableRow>
              </TableBody>
            </Table>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                   <h4><b>CGT Payable</b></h4>
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.cgt.cgtPayable}
                  </TableCell>
                  
                </TableRow>
              </TableHead>
            </Table>


            <h1>Estate Duty</h1>

            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <b>Assets</b>
                  </TableCell>
                  <TableCell>

                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netEstateAssets}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Assets from balance sheet
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netAssets}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Farms
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netFarms}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Deemed Assets
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netDeemedAssets}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Policies on your life
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netPoliciesOnLife}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Policies with cash value
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netPoliciesWithChash}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Accrual clain against surviving spouse
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.assets.netAccrualClaim}
                  </TableCell>
                </TableRow>
                <TableRow>

                </TableRow>
                <TableRow>

                </TableRow>


                <TableRow>
                    <TableCell>
                      <b>Deductions</b>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {this.props.state.result.estateDuty.deductions.netDeductions}
                    </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Liabilities
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netLiabilities}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Administration
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netAdministration}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Funeral
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netFuneral}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Masters fees
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netMastersFee}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Executors fees
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netExectutorsFee}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Capital Gains Tax
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netCapitalGainTax}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Transfer costs
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netTransferCosts}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Value of assets bequethed to surviving spouse
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netBequethedAssets}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Cash bequests to spouse
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netCashBequestTospouse}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Bequests to charities
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netCashBequestToCharity}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Residue to surviving spouse
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netResidueTospouse}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Policies to surviving spouse
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netPoliciesToSpouse}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Accrual claim
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.deductions.netAccrualClaim}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <b>Nett Estate</b>
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.netEstate}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    Minus: Rebate
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.minusRebate}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Minus: Rebate carried from previous spouse
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.minusRebateFromPreviousSpouse}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <b>Taxable Estate</b>
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.taxableEstate}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <b>Estate Duty payable</b>
                  </TableCell>
                  <TableCell>
                   
                  </TableCell>
                  <TableCell>
                    {this.props.state.result.estateDuty.estateDutyPayable}
                  </TableCell>
                </TableRow>



              </TableBody>
            </Table>

            
            
            <Grid container>
              <GridItem xs={12} sm={12} md={6}>
              </GridItem>
            </Grid>
            </CardContent>
        </Card>
      </div>
    );
  }
}

export default OtherInformation;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/OtherInformation.jsx